import React, { useEffect, useState } from 'react';
import { useFormik } from 'formik';
import * as yup from 'yup';
import axios from 'axios';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { base_url } from '../../Utils/baseUrl';
import { NavLink, useNavigate } from 'react-router-dom';
import './signup.css';

function SignUp() {

  const [loading, setLoading] = useState(false);
  useEffect(() => {
    window.scrollTo(0, 0)
  }, [])

  const [showPassword, setShowPassword] = useState(false);
  const [success, setSuccess] = useState(false);
  const [isChecked, setIsChecked] = useState();
  const navigate = useNavigate();

  const togglePasswordVisibility = () => {
    setShowPassword((prev) => !prev);
  };

  const validationSchema = yup.object({
    // firstName: yup.string().required('firstname is required'),
    email: yup.string().email('Ugyldig Email').required('Email er Nødvendig'),
    password: yup
      .string()
      .required('Adgangskode er Nødvendig')
      .min(8, 'Adgangskode for Kort  - Skal være på mindst 8 tegn'),
    terms: yup.boolean().oneOf([true], 'Accepter Venligst Vilkår & Betingelser Får at bruge Onlineskolemad'),
  });

  const formik = useFormik({
    initialValues: {
      // firstName: '',
      email: '',
      password: '',
      terms: false,
    },

    validationSchema: validationSchema,
    onSubmit: (values) => {
      try {
        setLoading(true);
        // if (!values.recaptcha) {
        //   toast.error('Please complete the CAPTCHA');
        //   return;
        // }
        delete values.terms;
        axios.post(`${base_url}auth/register`, values).then((res) => {
          // toast.success(res.data.message);
          setLoading(false);
          setSuccess(true);
        }).catch((err) => {
          toast.error(err.response.data.message);
          setLoading(false);
          setTimeout(() => {
            navigate("/login");
          }, 2000);
        });
      } catch (error) {
        toast.error('Please wait!! Something went wrong !!');
      }
    },
  });

  if (success) {
    setTimeout(() => {
      navigate("/verifyOtp", {
        state: {
          email: formik.values.email
        }
      });
    }, 1000);
  }

  return (
    <React.Fragment>
      <main>
        <section className="login-sec signup-sec wow pulse">
          <div className="container">
            <div className="login-inner">
              <div className="row">
                <div className="col-md-6">
                  <form className="form_elements" onSubmit={formik.handleSubmit}>
                    <div className="form-title">
                      <h2> Opret Bruger</h2>
                    </div>
                    {/* <div className="form-group ">
                      <div className="label_wrap">
                        <label htmlFor="firstName">Username</label>
                        <abbr>*</abbr>
                      </div>
                      <input
                        type="text"
                        className="form-control"
                        id="firstName"
                        name="firstName"
                        placeholder="firstName"
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                        value={formik.values.firstName}
                      />
                      {formik.touched.firstName && formik.errors.firstName ? (
                        <div className="error-message">{formik.errors.firstName}</div>
                      ) : null}
                    </div> */}
                    <div className="form-group ">
                      <div className="label_wrap">
                        <label htmlFor="email">Email ID</label>
                        <abbr>*</abbr>
                      </div>
                      <input
                        type="email"
                        className={`form-control ${formik.touched.email && formik.errors.email ? "input-error" : ""}`}
                        id="email"
                        name="email"
                        placeholder="Email"
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                        value={formik.values.email}
                      />
                      {formik.touched.email && formik.errors.email ? (
                        <div className="error-message-login">
                          <span className="error-dot"></span>
                          <span>{formik.errors.email}</span>
                        </div>
                      ) : null}
                    </div>
                    <div className="form-group ">
                      <div className="label_wrap">
                        <label htmlFor="password">Adgangskode</label>
                        <abbr>*</abbr>
                      </div>
                      <div className="password-input-wrapper">
                        <input
                          type={showPassword ? "text" : "password"}
                          className={`form-control password-input ${formik.touched.password && formik.errors.password ? "input-error" : ""}`}
                          id="password"
                          name="password"
                          placeholder="Adgangskode"
                          onChange={formik.handleChange}
                          onBlur={formik.handleBlur}
                          value={formik.values.password}
                        />
                        <button
                          type="button"
                          className="password-toggle-btn"
                          onClick={togglePasswordVisibility}
                          aria-label={showPassword ? 'Hide password' : 'Show password'}
                        >
                          <i className={`fa ${showPassword ? 'fa-eye-slash' : 'fa-eye'}`} aria-hidden="true" />

                        </button>
                      </div>
                      {formik.touched.password && formik.errors.password ? (
                        <div className="error-message-login">
                          <span className="error-dot"></span>
                          {formik.errors.password}
                        </div>
                      ) : null}
                    </div>
                    {/* reCAPTCHA component */}
                    {/* <div className="form-group">
                    <ReCAPTCHA
                      sitekey="Your reCAPTCHA Site Key"
                      onChange={(value) => formik.setFieldValue("recaptcha", value)}
                    />
                  </div> */}
                    <div className="form-group justify-content-between">
                      <div className="form_check">
                        <label className="form-check-label1" htmlFor="gridCheck1">
                          Har du allerede en konto?{' '}
                          <NavLink className="text-decoration-none" to="/login" >
                            Log ind
                          </NavLink>
                        </label>
                      </div>
                      <br />

                      <div className="form_check" style={{ display: "flex" }}>
                        <input
                          style={{ marginRight: '10px' }}
                          className={`form-check-input ${formik.touched.terms && formik.errors.terms ? "input-error" : ""}`}
                          type="checkbox"
                          id="gridCheck"
                          checked={formik.values.terms}
                          onChange={() => {
                            formik.setFieldValue("terms", !formik.values.terms);
                            setIsChecked(!isChecked);
                          }}
                        />
                        <label className="form-check-label" htmlFor="gridCheck">
                          <abbr style={{ color: 'red', position: "relative", right: "6px" }} >*</abbr>
                          Jeg Accepterer&nbsp;
                          <NavLink className="text-decoration-none" to="/terms" style={{ color: '#1cc88a!important' }} >
                            <u>Vilkår</u> & <u> Betingelser{' '}</u>
                          </NavLink>
                          {formik.touched.terms && formik.errors.terms ? (
                            <div className="error-message-login">
                              <i className="fa fa-exclamation-circle" aria-hidden="true" style={{ height: '35px' }}></i>
                              {formik.errors.terms}
                            </div>
                          ) : null}

                        </label>
                      </div>
                    </div>
                    <div className="btn_submit">
                      {loading === false
                        ? <button type="submit" className="btn btn-1 w-100">Opret Bruger</button>
                        : <button type="button" className="btn btn-1 w-100">Loading ....</button>
                      }
                    </div>
                  </form>
                </div>
                <div className="col-md-6">
                  <div className="login-img">
                    {/* Your other content goes here */}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      </main>
    </React.Fragment>
  );
}

export default SignUp;
